import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

import bankNoteIcon from '../../../../commons/src/assets/icons/bank-note.svg'
import coinsHandIcon from '../../../../commons/src/assets/icons/coins-hand.svg'
import fileNoteIcon from '../../../../commons/src/assets/icons/file-note.svg'
import infillIcon from '../../../../commons/src/assets/icons/infill.svg'
import rulerIcon from '../../../../commons/src/assets/icons/ruler.svg'
import snailIcon from '../../../../commons/src/assets/icons/snail.svg'
import targetIcon from '../../../../commons/src/assets/icons/target.svg'
import zapFastIcon from '../../../../commons/src/assets/icons/zap-fast.svg'
import zapIcon from '../../../../commons/src/assets/icons/zap.svg'

import Icon from '../../../../commons/src/components/icon'
import {IconSource} from '../../../../commons/src/components/icon/icon'
import Tooltip from '../../../../commons/src/components/tooltip'
import TooltipHandler from '../../../../commons/src/components/tooltip-handler'

const orderTagTypes = [
  'economy',
  'expedited',
  'express',
  'needsScaling',
  'noteAttached',
  'orderNoteAttached',
  'hasAdditionalCost',
  'isManualOrder',
  'hasRefundRequest',
]

export type OrderTagType = (typeof orderTagTypes)[number]
interface Props {
  classNames?: string[]
  type: OrderTagType
}

type TagContent = {
  iconSource: IconSource
  tooltipContent: string
}

export const typeToTagContentMap: Record<OrderTagType, TagContent> = {
  economy: {
    iconSource: snailIcon,
    tooltipContent: 'Economy production',
  },
  expedited: {
    iconSource: zapIcon,
    tooltipContent: 'Expedited production',
  },
  express: {
    iconSource: zapFastIcon,
    tooltipContent: 'Express shipping',
  },
  infill: {
    iconSource: infillIcon,
    tooltipContent: 'Infill specified',
  },
  needsScaling: {
    iconSource: rulerIcon,
    tooltipContent: 'Needs scaling',
  },
  noteAttached: {
    iconSource: fileNoteIcon,
    tooltipContent: 'Customer note attached',
  },
  orderNoteAttached: {
    iconSource: fileNoteIcon,
    tooltipContent: 'Order note attached',
  },
  hasAdditionalCost: {
    iconSource: bankNoteIcon,
    tooltipContent: 'Additional cost requested',
  },
  isManualOrder: {
    iconSource: targetIcon,
    tooltipContent: 'Manual order',
  },
  hasRefundRequest: {
    iconSource: coinsHandIcon,
    tooltipContent: 'Refund requested',
  },
}

const OrderTag = ({classNames, type}: Props) => (
  <span className={cn('OrderTag', {[`type-${type}`]: !!type}, classNames)}>
    <TooltipHandler
      key={type}
      openOnHover
      timeout={150}
      tooltip={<Tooltip appearance="dark">{typeToTagContentMap[type].tooltipContent}</Tooltip>}
    >
      <Icon source={typeToTagContentMap[type].iconSource} />
    </TooltipHandler>
  </span>
)

export default OrderTag
